<template>
  <div class="row">
    <div class="col-md-12">
      <form>
        <div class="">
          <ul class="nav nav-tabs small">
            <li
              v-for="tab in tabData"
              :key="tab.id"
              @click="selectTab(tab.id)"
              :class="[currentTab == tab.id ? 'active' : 'li-tabs']"
            >
              {{ tab.name }}
            </li>
          </ul>
        </div>

        <div class="row mt-3">
          <div class="col-sm-12">
            <div v-for="tab in tabData" :key="tab.id">
              <div v-if="tab.id == currentTab">
                <component :is="tab.component" v-bind="tab.component" />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <input
              type="submit"
              value="Insert Client Profile"
              class="btn btn-primary"
              @click="onSubmit"
            />
          </div>
        </div>
      </form>
    </div>
    <div class="row">
      <fieldset class="mt-4 ml-3">
        <legend>Delete client</legend>
        <form method="POST">
          <div class="row px-2">
            <div class="col-md-12">
              <div class="form-group">
                <label class="form-label" for="comments"
                  >Why is this client being deleted?</label
                >
                <textarea
                  cols="60"
                  rows="5"
                  name="comments"
                  class="form-control"
                ></textarea>
              </div>
              <div class="form-group mt-3">
                <input
                  type="Submit"
                  value="Delete this client"
                  class="btn btn-danger"
                />
              </div>
            </div>
          </div>
        </form>
      </fieldset>
    </div>
  </div>
</template>
<script>
import BasicSettings from "./clientmodule/BasicSettings.vue";
import BravoModule from "./clientmodule/BravoModule";
import AceModule from "./clientmodule/AceModule";
import Miscellaneous from "./clientmodule/Miscellaneous";
import UserOptions from "./clientmodule/UserOptions";
import ClientAdmins from "./clientmodule/ClientAdmins";
import SeparateClient from "./clientmodule/SeparateClient";
import ShippingAddress from "./clientmodule/ShippingAddress";

export default {
  name: "AddClientForm",
  components: {
    BasicSettings,
    BravoModule,
    AceModule,
    Miscellaneous,
    UserOptions,
    ClientAdmins,
    SeparateClient,
    ShippingAddress,
  },
  data() {
    return {
      currentTab: 1,
      tabData: [
        {
          id: 1,
          name: "Basic settings",
          component: BasicSettings,
        },
        {
          id: 2,
          name: "Bravo module edit info",
          component: BravoModule,
        },
        {
          id: 3,
          name: "Ace module edit info",
          component: AceModule,
        },
        {
          id: 4,
          name: "Miscellaneous",
          component: Miscellaneous,
        },
        {
          id: 5,
          name: "User options",
          component: UserOptions,
        },
        {
          id: 6,
          name: "Client admins",
          component: ClientAdmins,
        },
        {
          id: 7,
          name: "Separate client front page",
          component: SeparateClient,
        },
        {
          id: 8,
          name: "Shipping address",
          component: ShippingAddress,
        },
      ],
    };
  },
  computed: {
    form() {
      return this.$store.state.manageClients.form;
    },
  },
  methods: {
    selectTab(selectedTab) {
      this.currentTab = selectedTab;
    },
    onSubmit(e) {
      e.preventDefault();
      if (this.form.ratio === null) {
        alert("Please enter valid ratio");
        return;
      }
      if (this.form.taico_email != "") {
        if (
          !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
            this.form.taico_email
          )
        ) {
          alert("Invalid email address");
          return;
        }
      }
      this.$store.dispatch("manageClients/addClient", this.form).then(() => {
        this.$router.push("/client-management");
      });
    },
  },
  destroyed() {
    this.form.name = "";
    this.form.ratio = null;
  },
};
</script>

<style>
.nav {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-tabs {
  border-bottom: 1px solid #ddd;
  list-style: none;
}

.li-tabs {
  font-size: 95%;
  list-style: none;
  border: 1px solid transparent;
  /* border-bottom-color: none; */
  text-decoration: none;
  color: #2980b9;
  display: inline-block;
  margin: 0px 8px 8px 0px;
  padding: 10px 15px;
  cursor: pointer;
  margin-bottom: -0.5px;
  /* border-radius: 4px 4px 0 0; */
}

.li-tabs:hover {
  background-color: #eee;
}

.active {
  font-size: 95%;
  list-style: none;
  border: 1px solid #ddd;
  border-bottom: none;
  text-decoration: none;
  color: #777;
  display: inline-block;
  margin: 0px 8px 8px 0px;
  padding: 10px 15px;
  cursor: pointer;
  margin-bottom: -0.5px;
  border-radius: 4px 4px 0 0;
}

.nav-tabs {
  padding-left: 0px;
  margin: 0px;
}

form label {
  font-size: 15px;
  font-weight: bold;
}

fieldset {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 1.4em;
  margin: 0 0 1.5em 0;
}

.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
}

.form-check {
  padding-left: 2rem;
}

legend {
  position: absolute;
  font-size: 100%;
  width: auto;
  padding: 0px 5px;
  border: none;
  margin-top: -30px;
  font-weight: bold;
  background-color: white;
}

.small {
  font-size: 90%;
}
</style>
